"use strict";
var lodash_1 = require("lodash");
function MultiMatchQuery(query, options) {
    if (!query) {
        return;
    }
    return {
        multi_match: lodash_1.assign({ query: query }, options)
    };
}
exports.MultiMatchQuery = MultiMatchQuery;
//# sourceMappingURL=MultiMatchQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/query/query_dsl/full_text/MultiMatchQuery.js
// module id = 358
// module chunks = 0